module.exports = __webpack_public_path__ + "img/56.8dd6d47c.jpg";